import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { createRoot } from 'react-dom/client'

import App from './components/App'
import reportWebVitals from './reportWebVitals'
import Home from './components/Home'
import Result from './components/Result'
import {PickTeam} from './components/PickTeam'
import {PlayersCadence} from './views/PlayersCadence'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement as HTMLElement);

root.render(
  <BrowserRouter>
    <App>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pick-teams/:resultCode" element={<PickTeam />} />
        <Route path="/results/:resultCode" element={<Result />} />
        <Route path="/players-cadence/:resultCode" element={<PlayersCadence />} />
      </Routes>
    </App>
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
